import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { notificationTypes } from 'lib/notificationTypes';

const Toast = ({ message, type = 'info', timeout = 3000, onClose }) => {
  const [isExiting, setIsExiting] = useState(false);

  const startExit = useCallback(() => {
    setIsExiting(true);
    setTimeout(onClose, 300);
  }, [onClose]);

  useEffect(() => {
    const timer = setTimeout(startExit, timeout);
    return () => clearTimeout(timer);
  }, [startExit, timeout]);

  const styles = notificationTypes[type] || notificationTypes.info;

  return (
    <div
      className={`
        fixed top-4 left-1/2 -translate-x-1/2 z-50
        transition-all duration-300 ease-out
        ${isExiting ?
          'opacity-0 -translate-y-2' :
          'opacity-100 translate-y-0 animate-toast-enter'
        }
      `}
      onClick={startExit}
      style={{
        '--enter-start': '-0.5rem',
        '--enter-end': '0'
      }}
    >
      <div className={`
        px-6 py-3 rounded-lg shadow-lg cursor-pointer
        border bg-gray-weakest ${styles.border} ${styles.text}
        transform transition-transform hover:scale-[0.98] active:scale-[0.97]
      `}>
        <div className="flex items-center space-x-2">
          <i className={`${styles.icon} flex-shrink-0 w-5`} aria-hidden="true" />
          <span className="font-medium">{message}</span>
        </div>
      </div>
    </div>
  );
};

Toast.propTypes = {
  type: PropTypes.oneOf(['info', 'danger', 'success', 'warning', 'dark']),
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default Toast;
